import { render, staticRenderFns } from "./TasksListGrid.vue?vue&type=template&id=55479a40&scoped=true&"
import script from "./TasksListGrid.vue?vue&type=script&lang=js&"
export * from "./TasksListGrid.vue?vue&type=script&lang=js&"
import style0 from "./TasksListGrid.vue?vue&type=style&index=0&id=55479a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55479a40",
  null
  
)

export default component.exports